import { KeycloakInstance } from 'keycloak-js';
import { RoleKey } from '../models/roleDto';

const hasRoles = (roles: RoleKey[], keycloak: KeycloakInstance) => {
  return roles.some((r) => {
    const realm = keycloak.hasRealmRole(r);
    const resource = keycloak.hasResourceRole(r);
    return realm || resource;
  });
};

export default hasRoles;
